export default {
  name: 'App',
  data() {
    return {
      authState: null,
      blockPage: {},
      checkinTimer: null,
      fingerprint: null,
      licenseServer: null,
      projectName: null
    };
  },
  computed: {
    blockPageStyle() {
      return {
        backgroundColor: this.blockPage.backgroundColor || '#1a1a2e',
        color: this.blockPage.textColor || '#ffffff'
      };
    }
  },
  async mounted() {
    await this.checkAuth();
    this.startCheckin();
  },
  beforeUnmount() {
    if (this.checkinTimer) clearInterval(this.checkinTimer);
  },
  methods: {
    async checkAuth() {
      try {
        const res = await fetch('/api/auth/status');
        const json = await res.json();
        if (json.isSuccess && json.data) {
          this.fingerprint = json.data.fingerprint;
          this.licenseServer = json.data.licenseServer;
          this.projectName = json.data.projectName;
          if (json.data.authorized) {
            this.authState = true;
          } else {
            this.authState = false;
            await this.fetchBlockPage();
          }
        } else {
          this.authState = false;
        }
      } catch {
        this.authState = false;
      }
    },
    async fetchBlockPage() {
      if (!this.fingerprint || !this.licenseServer || !this.projectName) return;
      try {
        const res = await fetch(`${this.licenseServer}/license/status/${this.projectName}/${this.fingerprint}`);
        const json = await res.json();
        if (json.data && json.data.blockPage) {
          this.blockPage = json.data.blockPage;
        }
      } catch {
        this.blockPage = {
          title: '服务未授权',
          html: '<p>本系统未获得使用授权，请联系管理员获取授权后使用。</p>',
          backgroundColor: '#1a1a2e',
          textColor: '#ffffff'
        };
      }
    },
    startCheckin() {
      this.checkinTimer = setInterval(async () => {
        await this.checkAuth();
      }, 3 * 60 * 1000);
    }
  }
};